import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { ConfirmNewEmailChangeData, ConfirmOldEmailChangeData, CreateEmailChangeData, EmailChangeDoneResponse, EmailChangePendingNewConfirm, EmailChangePendingOldConfirm, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function emailChange(config) {
    const confirmNewResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(EmailChangeDoneResponse)),
    });
    const confirmOldResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(EmailChangePendingNewConfirm)),
    });
    const createResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ parsers.taggedUnion('status', [
            ['pending_old_confirm', EmailChangePendingOldConfirm],
            ['pending_new_confirm', EmailChangePendingNewConfirm],
        ]))),
    });
    return Object.freeze({
        /**
         * Verify the new-email code and complete the email change.
         *
         * Only valid for sessions in `pending_new_confirm` status. On success, the user's email is updated and marked as verified.
         *
         * Does not require authentication — the token in the URL is the credential. IP-bound to the initiating client.
         *
         * @param arg The arguments to the function.
         * @param arg.token The email change session identifier.
         * @param arg.requestBody The body of the request.
         * @returns The new email address.
         */
        confirmNew: async ({ token, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/email_changes/${token}/confirm_new`, confirmNewResponse.v, JSON.stringify(ConfirmNewEmailChangeData.encode(requestBody)));
            return result;
        },
        /**
         * Verify the old-email code and send a code to the new email.
         *
         * Only valid for sessions in `pending_old_confirm` status (Path B: no-password users). On success, transitions to `pending_new_confirm` and sends a code to the new email. Call `email_change.confirm_new` next.
         *
         * Does not require authentication — the token in the URL is the credential. IP-bound to the initiating client.
         *
         * @param arg The arguments to the function.
         * @param arg.token The email change session identifier.
         * @param arg.requestBody The body of the request.
         * @returns An empty response on success.
         */
        confirmOld: async ({ token, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/email_changes/${token}/confirm_old`, confirmOldResponse.v, JSON.stringify(ConfirmOldEmailChangeData.encode(requestBody)));
            return result;
        },
        /**
         * Initiate an email change.
         *
         * If the user has a password and provides `old_password`, the flow skips old-email verification and goes straight to new-email verification (call `email_change.confirm_new`).
         *
         * If the user has no password (SSO/LTI), old-email verification is required first (call `email_change.confirm_old`, then `email_change.confirm_new`).
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns An email change session identifier.
         */
        create: async ({ requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/email_changes/`, createResponse.v, JSON.stringify(CreateEmailChangeData.encode(requestBody)));
            return result;
        },
    });
}
